import { useRef, useState, Fragment } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Field, FieldArray, useFormikContext } from 'formik'

import TextBox from 'components/TextBox'
import Select from 'components/Select'
import useScrollToAddedSection from 'hooks/useScrollToAddedSection'
import { getHasModifierGroups } from 'store/Categories/selectors'
import { filteredModifiersOptionsByTakenOptions } from 'utils/items'

const HasModifierGroups = ({ id }) => {
  const { values, setFieldValue, initialValues } = useFormikContext()

  const hasModifierGroups = useSelector(getHasModifierGroups)

  const settingsRefs = useRef([])
  const [indexToRemove, setIndexToRemove] = useState(null)

  const { removeSectionFromSectionsRefs } = useScrollToAddedSection(
    settingsRefs,
    values.hasModifierGroups,
    indexToRemove,
    initialValues.hasModifierGroups
  )

  const filteredSelectOptions = (index) => {
    return filteredModifiersOptionsByTakenOptions(
      index,
      hasModifierGroups,
      values.hasModifierGroups,
      values.belongsToModifierGroups
    )
  }

  const handleAddClick = (handlePush) => () => {
    handlePush({
      modifierGroupUuid: null,
      minimumCount: null,
      maximumCount: null,
      secondaryPriceThresholdCount: null,
    })
  }

  const handleRemoveClick = (index, remove) => () => {
    remove(index)
    setIndexToRemove(index)
    removeSectionFromSectionsRefs()
  }

  return (
    <section id={id}>
      <h3 id={id} className="header-title">
        Has Modifier Groups
      </h3>
      <span>Use when assigning modifier groups to this item</span>
      <FieldArray name="hasModifierGroups">
        {({ push, remove }) => (
          <>
            <div className="add-new-section-btn">
              <span>Add another Modifier Group</span>
              <button
                onClick={handleAddClick(push)}
                className="btn plus -plus-sm"
                type="button"
              >
                <span className="plus--cross"></span>
                <span className="plus--cross"></span>
              </button>
            </div>
            {values.hasModifierGroups.map((_, index) => (
              <Fragment key={index}>
                <div className="add-new-section-btn">
                  <span>Modifier Group Settings</span>
                  <button
                    onClick={handleRemoveClick(index, remove)}
                    className="btn minus -minus-sm"
                    type="button"
                  >
                    <span className="minus--icon"></span>
                  </button>
                </div>
                <div className="content-wrapper">
                  <Select
                    key={
                      values.hasModifierGroups[index]
                        .modifierGroupUuid
                    }
                    label="Modifier Group"
                    name={`hasModifierGroups.${index}.modifierGroupUuid`}
                    options={filteredSelectOptions(index)}
                    defaultValue={
                      values.hasModifierGroups[index]
                        .modifierGroupUuid
                    }
                    handleChange={(value) =>
                      setFieldValue(
                        `hasModifierGroups.${index}.modifierGroupUuid`,
                        value
                      )
                    }
                  />
                </div>
                <div className="content-wrapper -more-space">
                  <Field
                    wrapperClassName="-space-right"
                    component={TextBox}
                    label="Minimum Required"
                    name={`hasModifierGroups.${index}.minimumCount`}
                  />
                  <Field
                    component={TextBox}
                    label="Maximum Allowed"
                    name={`hasModifierGroups.${index}.maximumCount`}
                  />
                </div>
                <div
                  className="content-wrapper"
                  ref={(ref) => (settingsRefs.current[index] = ref)}
                >
                  <Field
                    component={TextBox}
                    label="Maximum at Default Price"
                    name={`hasModifierGroups.${index}.secondaryPriceThresholdCount`}
                  />
                </div>
              </Fragment>
            ))}
          </>
        )}
      </FieldArray>
    </section>
  )
}

HasModifierGroups.propTypes = {
  id: PropTypes.string,
}

export default HasModifierGroups
